import React from 'react'
import SubPageHeader from '../components/subPageHeader'

export default ({ title, text, image, url }) => (
  <SubPageHeader
    title={title}
    text={text}
    background={image}
    currentUrl={url}
  />
)
